export default "__VITE_ASSET__BtHJHLVa__"